export const locale = {
    lang: "es",
    data: {
        MANAGER: {
            TITLE: "Supervisores",
            //'BADGE': '25'
        }, 
    },
};
 